import React from 'react';
import Button from '@material-ui/core/Button';
import MemberSubmissionService from '../../../services/MemberSubmissionService';
import Divider from '@material-ui/core/Divider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DateUtils from '../../../services/Utility/DateUtils';
import NotificationService, {
    NotificationTypes
} from '../../../services/NotificationService';

const inputStyle = {
    marginLeft: 8,
    flex: 1,
};
const dividerStyle = {
    width: 1,
    height: 28,
    margin: 4,
}

const startYear = 2019;

function MemberSubmissionsExport(props) {
    const [year, setYear] = React.useState(DateUtils.currentYear);
    const [disabled, setDisabled] = React.useState(false);

    function exportFile() {
        setDisabled(true);
        MemberSubmissionService.exportMemberSubmissions(year)
            .then(() => {
                setDisabled(false);
            })
            .catch((error) => {
                NotificationService.fireNotification(NotificationTypes.error, `Error ${error.message}`);
                setDisabled(false);
            });
    }

    function getYearOptions() {
        return Array((DateUtils.currentYear + 1) - startYear)
            .fill()
            .map((_, i) =>
                <MenuItem key={i} value={startYear + i}>{startYear + i}</MenuItem>
            );
    };

    return (
        <React.Fragment>
            <Select
                style={inputStyle}
                value={year}
                onChange={e => setYear(e.target.value)}
            >
                {getYearOptions()}
            </Select>
            <Divider style={dividerStyle} />
            <Button disabled={disabled} onClick={exportFile}>Export Member Submissions</Button>
        </React.Fragment>
    );
}

export default MemberSubmissionsExport;
